"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _Text = _interopRequireDefault(require("../text/Text"));

var _ProgressBar = _interopRequireDefault(require("../effect/ProgressBar"));

var _StaggeredFadeIn = _interopRequireDefault(require("../effect/animation/StaggeredFadeIn"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CircleSize = 28;

var StepsIndicator = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(StepsIndicator, _Component);

  var _super = _createSuper(StepsIndicator);

  function StepsIndicator() {
    var _this;

    (0, _classCallCheck2["default"])(this, StepsIndicator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(StepsIndicator, [{
    key: "renderStep",
    value: function renderStep(_ref, index) {
      var title = _ref.title,
          clickable = _ref.clickable;
      var _this$props = this.props,
          currentIndex = _this$props.completedIndex,
          onClickStep = _this$props.onClickStep;
      var cursorStyles = [clickable === true && this.styles.clickable, clickable === false && this.styles.nonClickable];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _styling.css.apply(void 0, [this.styles.stepContainer].concat(cursorStyles)),
        key: "".concat(title, "-").concat(index),
        onClick: onClickStep && function () {
          return onClickStep(index);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        className: _styling.css.apply(void 0, [this.styles.circle, currentIndex == index ? this.styles.currentCircle : this.styles.nonCurrentCircle].concat(cursorStyles))
      }, index + 1), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        className: _styling.css.apply(void 0, [this.styles.stepTitle, currentIndex == index ? this.styles.currentText : this.styles.nonCurrentText].concat(cursorStyles)),
        weight: currentIndex == index ? "semibold" : "regular"
      }, title));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var borderPrimary = this.context.theming.theme.borderPrimary;
      var _this$props2 = this.props,
          steps = _this$props2.steps,
          className = _this$props2.className,
          _this$props2$color = _this$props2.color,
          color = _this$props2$color === void 0 ? borderPrimary : _this$props2$color;

      if (steps.length < 2) {
        // Looks bad if there is only one step.
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.lineContainer)
      }, /*#__PURE__*/_react["default"].createElement(_ProgressBar["default"], {
        color: color,
        progress: this.completionPercentage,
        backgroundColor: borderPrimary,
        height: 1,
        noRadius: true
      })), /*#__PURE__*/_react["default"].createElement(_StaggeredFadeIn["default"], {
        deltaX: 0,
        deltaY: 0,
        className: (0, _styling.css)(this.styles.content)
      }, steps.map(function (step, index) {
        return _this2.renderStep(step, index);
      })));
    }
  }, {
    key: "completionPercentage",
    get: function get() {
      var _this$props3 = this.props,
          steps = _this$props3.steps,
          completedIndex = _this$props3.completedIndex;

      if (completedIndex == null || completedIndex === 0) {
        return 0;
      }

      if (completedIndex === steps.length - 1) {
        return 1;
      }

      var isMiddleStep = steps.length % 2 === 1 && completedIndex === Math.floor(steps.length / 2);

      if (isMiddleStep) {
        return 0.5;
      }

      return Math.min(Math.max((completedIndex + 0.5) / steps.length, 0), 1);
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming = this.context.theming.theme,
          primary = _this$context$theming.primary,
          textWhite = _this$context$theming.textWhite,
          surfaceLightest = _this$context$theming.surfaceLightest,
          textLight = _this$context$theming.textLight,
          borderPrimary = _this$context$theming.borderPrimary;
      return _aphrodite.StyleSheet.create({
        root: {
          position: "relative"
        },
        content: {
          display: "flex",
          flexDirection: "row",
          position: "relative"
        },
        lineContainer: {
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: CircleSize,
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "center"
        },
        stepContainer: {
          display: "flex",
          flexGrow: 1,
          flexBasis: 0,
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          ":first-child": {
            alignItems: "flex-start",
            textAlign: "left"
          },
          ":last-child": {
            alignItems: "flex-end",
            textAlign: "right"
          }
        },
        circle: {
          height: CircleSize,
          width: CircleSize,
          borderRadius: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "default",
          userSelect: "none",
          fontSize: 13,
          transition: "background-color 0.6s linear"
        },
        currentCircle: {
          color: textWhite,
          backgroundColor: primary,
          border: "1px solid ".concat(primary)
        },
        nonCurrentCircle: {
          color: textLight,
          backgroundColor: surfaceLightest,
          border: "1px solid ".concat(borderPrimary)
        },
        currentText: {
          color: primary
        },
        nonCurrentText: {
          color: textLight
        },
        stepTitle: {
          fontSize: 14,
          marginTop: 12,
          cursor: "default",
          userSelect: "none"
        },
        clickable: {
          cursor: "pointer"
        },
        nonClickable: {
          cursor: "default"
        }
      });
    }
  }]);
  return StepsIndicator;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {
  steps: {
    required: true,
    type: "ReadonlyArray<{title: string, clickable?: boolean}>",
    description: "List of steps"
  },
  completedIndex: {
    required: true,
    type: "number",
    description: "Index of the last completed step"
  },
  onClickStep: {
    required: false,
    type: "(index: number) => mixed",
    description: "Callback when a step is clicked"
  },
  color: {
    required: false,
    type: "string",
    description: "Color of Step indicator. By default, Cyan (#1ACC94)"
  }
}, _class3.demoProps = {
  steps: [{
    title: "Select destination countries"
  }, {
    title: "Collect taxes for selected countries"
  }, {
    title: "Enter tax IDs"
  }, {
    title: "Review and submit"
  }],
  completedIndex: 1
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "completionPercentage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "completionPercentage"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = StepsIndicator;
exports["default"] = _default;